export interface HrRecruitmentDashboard {
  owningCompanyId?: number;
  openRequisitions?: number;
  activeCandidates?: number;
  activeApplications?: number;
  scheduledInterviews?: number;
  openOffers?: number;
  requisitions?: HrRequisition[];
  applications?: HrApplication[];
  offers?: HrOffer[];
}

export interface HrRequisition {
  requisitionId?: number;
  owningCompanyId?: number;
  requisitionCode?: string;
  requisitionTitle?: string;
  departmentId?: number;
  jobId?: number;
  positionId?: number;
  hiringManagerEmployeeId?: number;
  openings?: number;
  filledOpenings?: number;
  requisitionStatus?: string;
  priority?: string;
  workerCategory?: string;
  employmentType?: string;
  targetStartDate?: string;
  description?: string;
  notes?: string;
}

export interface HrCandidate {
  candidateId?: number;
  owningCompanyId?: number;
  candidateCode?: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  emailAddress?: string;
  phoneNumber?: string;
  candidateStatus?: string;
  sourceType?: string;
  sourceReference?: string;
  countryCode?: string;
  currentSponsor?: string;
  workStatus?: string;
  availabilityDate?: string;
  licenseClass?: string;
  yearsDriving?: number;
  preferredRoutes?: string;
  vehicleCategories?: string;
  safetyCertifications?: string;
  warehouseEquipmentSkills?: string;
  possibleDuplicate?: boolean;
  notes?: string;
  documents?: HrCandidateDocument[];
}

export interface HrApplication {
  applicationId?: number;
  owningCompanyId?: number;
  requisitionId?: number;
  requisitionCode?: string;
  requisitionTitle?: string;
  candidateId?: number;
  candidateName?: string;
  applicationCode?: string;
  applicationStatus?: string;
  stage?: string;
  complianceStatus?: string;
  complianceChecklistJson?: string;
  rejectionReason?: string;
  notes?: string;
  interviews?: HrInterview[];
}

export interface HrInterview {
  interviewId?: number;
  owningCompanyId?: number;
  applicationId?: number;
  candidateId?: number;
  requisitionId?: number;
  interviewType?: string;
  interviewStatus?: string;
  scheduledStartAt?: string;
  scheduledEndAt?: string;
  timezone?: string;
  location?: string;
  meetingUrl?: string;
  interviewerEmployeeId?: number;
  interviewerName?: string;
  score?: number;
  feedback?: string;
  notes?: string;
}

export interface HrOffer {
  offerId?: number;
  owningCompanyId?: number;
  applicationId?: number;
  candidateId?: number;
  candidateName?: string;
  requisitionId?: number;
  offerCode?: string;
  offerStatus?: string;
  offeredEmployeeNumber?: string;
  proposedStartDate?: string;
  expiryDate?: string;
  currencyCode?: string;
  baseSalary?: number;
  allowanceAmount?: number;
  offerPayloadJson?: string;
  reportTemplateId?: number;
  generatedDocumentUrl?: string;
  convertedEmployeeId?: number;
  notes?: string;
  approvals?: HrOfferApproval[];
}

export interface HrOfferApproval {
  offerApprovalId?: number;
  offerId?: number;
  approvalStatus?: string;
  approverCustomerId?: number;
  approverEmployeeId?: number;
  decisionAt?: string;
  sequenceNo?: number;
  comments?: string;
}

export interface HrCandidateDocument {
  candidateDocumentId?: number;
  owningCompanyId?: number;
  candidateId?: number;
  applicationId?: number;
  documentTypeCode?: string;
  documentName?: string;
  documentStatus?: string;
  documentUrl?: string;
  expiryDate?: string;
  notes?: string;
}

export interface HrRecruitmentDecisionRequest {
  owningCompanyId?: number;
  status?: string;
  reason?: string;
  notes?: string;
}

export interface HrApplicationStageTransitionRequest {
  owningCompanyId?: number;
  stage?: string;
  complianceStatus?: string;
  complianceChecklistJson?: string;
  rejectionReason?: string;
  notes?: string;
}

export interface HrOfferDecisionRequest {
  owningCompanyId?: number;
  decision?: string;
  comments?: string;
}

export interface HrOfferConversionRequest {
  owningCompanyId?: number;
  employeeNumber?: string;
  employeeType?: string;
  workerCategory?: string;
  departmentId?: number;
  jobId?: number;
  positionId?: number;
  managerEmployeeId?: number;
  workLocationId?: number;
  workLocation?: string;
  startDate?: string;
  startOnboarding?: boolean;
  onboardingTemplateId?: number;
  onboardingTargetCompletionDate?: string;
  notes?: string;
}

export interface HrCandidateImportRequest {
  owningCompanyId?: number;
  requisitionId?: number;
  createApplications?: boolean;
  candidates?: HrCandidate[];
}

export interface HrCandidateImportResult {
  owningCompanyId?: number;
  received?: number;
  created?: number;
  duplicates?: number;
  applicationsCreated?: number;
  candidates?: HrCandidate[];
  warnings?: string[];
}

export const HR_REQUISITION_STATUSES = ['DRAFT', 'PENDING_APPROVAL', 'OPEN', 'CLOSED', 'CANCELLED'];

export const HR_APPLICATION_STAGES = ['APPLIED', 'SCREENING', 'INTERVIEW', 'OFFER', 'HIRED', 'REJECTED'];

export const HR_OFFER_STATUSES = ['DRAFT', 'PENDING_APPROVAL', 'APPROVED', 'SENT', 'ACCEPTED', 'DECLINED', 'CONVERTED'];

